import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  data() {
    return {
      myName: '测试支付啊AA'
    }
  },
  routes: [
    // {
    //   path: '/',
    //   redirect: '/user', 
    //   component: () => import('./views/user/login.vue'),
    //   children: [
    //     {
    //       path: 'user',
    //       component: () => import('./views/user/login.vue'),
    //       meta: { title: '登录' }
    //     }
    //   ]
    // },
    {
      path: '/',
      redirect: '/user',
      component: () => import('./views/user/buyShebei.vue'),
      children: [
        {
          path: 'user',
          component: () => import('./views/user/buyShebei.vue'),
          meta: { title: '设备' }
        }
      ]
    },
    {
      path: '/user/bindPhone',
      component: () => import('./views/user/bindPhone.vue')
    },
    {
      path: '/user/staticpage',
      component: () => import('./views/user/staticpage.vue'),
      meta: { title: '促销活动' }
    },
    {
      name: 'applyTui',
      path: '/user/applyTui',
      component: () => import('./views/user/applyTui.vue'),
      meta: { title: '余额领取' }
    },
    {
      name: 'me',
      path: '/user/me',
      component: () => import('./views/user/me.vue'),
      meta: { title: '我的' }
    },

    {
      path: '/xin/me',
      component: () => import('./views/xin/me.vue'),
      meta: { title: '我的' }
    },
    {
      path: '/xin/miBindPhone',
      component: () => import('./views/xin/miBindPhone.vue'),
      meta: { title: '注册登录' }
    },
    {
      path: '/xin/buyShebeiSelect',
      component: () => import('./views/xin/buyShebeiSelect.vue'),
      meta: { title: '查询订单' }
    },
    {
      path: '/xin/buyShebei',
      component: () => import('./views/xin/buyShebei.vue'),
      meta: { title: '首页' }
    },


    {
      path: '/wu/me',
      component: () => import('./views/wu/me.vue'),
      meta: { title: '我的' }
    },
    {
      path: '/wu/miBindPhone',
      component: () => import('./views/wu/miBindPhone.vue'),
      meta: { title: '注册登录' }
    },
    {
      path: '/wu/buyShebeiSelect',
      component: () => import('./views/wu/buyShebeiSelect.vue'),
      meta: { title: '查询订单' }
    },
    {
      path: '/wu/buyShebei',
      component: () => import('./views/wu/buyShebei.vue'),
      meta: { title: '首页' }
    },

    {
      path: '/you/me',
      component: () => import('./views/you/me.vue'),
      meta: { title: '我的' }
    },
    {
      path: '/you/miBindPhone',
      component: () => import('./views/you/miBindPhone.vue'),
      meta: { title: '注册登录' }
    },
    {
      path: '/you/buyShebeiSelect',
      component: () => import('./views/you/buyShebeiSelect.vue'),
      meta: { title: '查询订单' }
    },
    {
      path: '/you/buyShebei',
      component: () => import('./views/you/buyShebei.vue'),
      meta: { title: '首页' }
    },
    {
      path: '/you/buyShebeiInfo',
      component: () => import('./views/you/buyShebeiInfo.vue'),
      meta: { title: '设备详情' }
    },










    {
      path: '/user/loginTest',
      component: () => import('./views/user/loginTest.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/user/service',
      component: () => import('./views/user/service.vue'),
      meta: { title: '查询办理服务' }
    },
    {
      path: '/user/userAgreement',
      component: () => import('./views/user/userAgreement.vue'),
      meta: { title: '订购' }
    },


    {
      path: '/user/miBindPhone',
      component: () => import('./views/user/miBindPhone.vue'),
      meta: { title: '注册登录' }
    },



    {
      path: '/user/guangdianAuth',
      component: () => import('./views/user/guangdianAuth.vue'),
      meta: { title: '实名登记' }
    },
    {
      path: '/user/cuccToAuth',
      component: () => import('./views/user/cuccToAuth.vue'),
      meta: { title: '实名登记' }
    },
    {
      path: '/user/cuccToAuthTest',
      component: () => import('./views/user/cuccToAuthTest.vue'),
      meta: { title: '实名登记' }
    },
    {
      path: '/user/cardOpens',
      component: () => import('./views/user/cardOpen.vue'),
      meta: { title: '设备激活' }
    },
    {
      path: '/user/loginOpens',
      component: () => import('./views/user/loginOpens.vue'),
      meta: { title: '查询办理' }
    },
    {
      name: 'winningRecord',
      path: '/user/winningRecord',
      component: () => import('./views/user/winningRecord.vue'),
      meta: { title: '中奖记录' }
    },
    {
      name: 'renew',
      path: '/user/renew',
      component: () => import('./views/user/renew.vue'),
      meta: { title: '套餐续费' }
    },

    {
      name: 'balanceRechargeApply',
      path: '/user/balanceRechargeApply',
      component: () => import('./views/user/balanceRechargeApply.vue'),
      meta: { title: '预存活动' }
    },

    {
      path: '/user/simOpenTnVip',
      component: () => import('./views/user/simOpenTnVip.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/user/cuccOpen',
      component: () => import('./views/user/cuccOpen.vue'),
      meta: { title: '' }
    },
    {
      path: '/user/cuccOpen1',
      component: () => import('./views/user/cuccOpen1.vue'),
      meta: { title: '' }
    },
    {
      path: '/user/cuccOpen2',
      component: () => import('./views/user/cuccOpen2.vue'),
      meta: { title: '' }
    },
    {
      path: '/user/cuccOpen3',
      component: () => import('./views/user/cuccOpen3.vue'),
      meta: { title: '' }
    },

    {
      path: '/newUser/simOpenTnVip',
      component: () => import('./views/newUser/simOpenTnVip.vue'),
      meta: { title: '优惠活动' }
    },

    {
      path: '/newUser/simOpenTnBz',
      component: () => import('./views/newUser/simOpenTnBz.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/bindNew/bindPhone',
      component: () => import('./views/newUser/bindNew/bindPhone.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/newUser/deposit',
      component: () => import('./views/newUser/bindNew/deposit.vue'),
      meta: { title: '合约押金' }
    },
    {
      path: '/newUser/bindNew/getCode',
      component: () => import('./views/newUser/bindNew/getCode.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/newUser/bindNew/bindingCard',
      component: () => import('./views/newUser/bindNew/bindingCard.vue'),
      meta: { title: '绑定' }
    },
    {
      path: '/newUser/simOpen100',
      component: () => import('./views/newUser/simOpen100.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simOpen105',
      component: () => import('./views/newUser/simOpen105.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simOpen108',
      component: () => import('./views/newUser/simOpen108.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simOpen999',
      component: () => import('./views/newUser/simOpen999.vue'),
      meta: { title: '优惠活动' }
    },

    {
      path: '/user/paymentAmount',
      component: () => import('./views/user/paymentAmount.vue'),
      meta: { title: '支付结果' }
    },
    {
      path: '/user/cuccImg',
      component: () => import('./views/user/cuccImg.vue'),
      meta: { title: '授权' }
    },
    {
      path: '/user/payOther',
      component: () => import('./views/user/payOther.vue'),
      meta: { title: '支付' }
    },
    {
      path: '/user/paymentAmountApp',
      component: () => import('./views/user/paymentAmountApp.vue'),
      meta: { title: '支付结果' }
    },

    {
      name: 'applyShop',
      path: '/user/applyShop',
      component: () => import('./views/user/applyShop.vue'),
      meta: { title: '兑换卷记录' }
    },
    {
      path: '/user/openPriceSim',
      component: () => import('./views/user/openPriceSim.vue'),
      meta: { title: '开户激活' }
    },
    {
      name: 'applySalePkg',
      path: '/user/applySalePkg',
      component: () => import('./views/user/applySalePkg.vue'),
      meta: { title: '兑换卷记录' }
    },
    {
      path: '/user/promotion',
      name: 'promotion',
      component: () => import('./views/user/promotion.vue'),
      meta: { title: '活动促销' }
    },
    {
      path: '/user/luckDraw',
      name: 'luckDraw',
      component: () => import('./views/user/luckDraw.vue'),
      meta: { title: '抽奖活动' }
    },
    {
      path: '/user/home',
      component: () => import('./views/user/home.vue'),
      meta: { title: '业务中心' }
    }, 

    {
      path: '/user/simLogin',
      component: () => import('./views/user/simLogin.vue'),
      meta: { title: '卡号登录' }
    },
     {
      path: '/newUser/simLoginBuyPrice',
      component: () => import('./views/newUser/simLoginBuyPrice.vue'),
      meta: { title: '卡号登录' }
    },

    {
      path: '/newUser/simLoginLaochang',
      component: () => import('./views/newUser/simLoginLaochang.vue'),
      meta: { title: '设备登录' }
    },
 

    {
      path: '/user/loginOnebutton',
      component: () => import('./views/user/loginOnebutton.vue'),
      meta: { title: '智能诊断' }
    },
    {
      path: '/user/simOpenXc',
      component: () => import('./views/user/simOpenXc.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simOpenXc',
      component: () => import('./views/newUser/simOpenXc.vue'),
      meta: { title: '优惠活动' }
    },

    {
      path: '/user/simOpenXy',
      component: () => import('./views/user/simOpenXy.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/user/simOpenXy8',
      component: () => import('./views/user/simOpenXy8.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simOpenXy8',
      component: () => import('./views/newUser/simOpenXy8.vue'),
      meta: { title: '优惠活动' }
    },

    {
      path: '/user/simOpenYx',
      component: () => import('./views/user/simOpenYx.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simOpenYx',
      component: () => import('./views/newUser/simOpenYx.vue'),
      meta: { title: '优惠活动' }
    },

    {
      path: '/user/simOpenTnP',
      component: () => import('./views/user/simOpenTnP.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/user/simOpenTnP',
      component: () => import('./views/user/simOpenTnP.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/user/simOpenTnP',
      component: () => import('./views/user/simOpenTnP.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/user/simOpenXcp',
      component: () => import('./views/user/simOpenXcp.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simOpenXcp',
      component: () => import('./views/newUser/simOpenXcp.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/user/simOpenTnPNew',
      component: () => import('./views/user/simOpenTnPNew.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simOpenTnPNew',
      component: () => import('./views/newUser/simOpenTnPNew.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/user/simOpenWu',
      component: () => import('./views/user/simOpenWu.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/user/simOpenWup',
      component: () => import('./views/user/simOpenWup.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simOpenWup',
      component: () => import('./views/newUser/simOpenWup.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simOpenWu',
      component: () => import('./views/newUser/simOpenWu.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simOpenTnP',
      component: () => import('./views/newUser/simOpenTnP.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simOpenTn',
      component: () => import('./views/newUser/simOpenTn.vue'),
      meta: { title: '优惠活动' }
    },

    {
      path: '/user/scanKefu',
      component: () => import('./views/user/scanKefu.vue'),
      meta: { title: '' }
    },
    {
      path: '/user/scanActive',
      component: () => import('./views/user/scanActive.vue'),
      meta: { title: '' }
    },


    {
      path: '/user/simOpenTn',
      component: () => import('./views/user/simOpenTn.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simOpenLe',
      component: () => import('./views/newUser/simOpenLe.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simOpenCxk',
      component: () => import('./views/newUser/simOpenCxk.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/user/simOpenCxk',
      component: () => import('./views/user/simOpenCxk.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/user/simOpenLe',
      component: () => import('./views/user/simOpenLe.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/user/simOpenLex',
      component: () => import('./views/user/simOpenLex.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/user/ctccAuth',
      component: () => import('./views/user/other/ctccAuth.vue'),
      meta: { title: '实名登记' }
    },
    {
      path: '/user/activity',
      component: () => import('./views/user/activity.vue'),
      meta: { title: '免费领取中51...' }
    },
    {
      path: '/user/loginAuth',
      component: () => import('./views/user/loginAuth.vue'),
      meta: { title: '移动实名' }
    },
    {
      path: '/user/loginAuthOther',
      component: () => import('./views/user/loginAuthOther.vue'),
      meta: { title: '移动实名' }
    },
    {
      path: '/user/appLoad',
      component: () => import('./views/user/AppLoad.vue'),
      meta: { title: 'APP下载' }
    },
    {
      path: '/user/AppLoadActive',
      component: () => import('./views/newUser/simLogin.vue'),
      meta: { title: '登录' }
    },

    {
      path: '/user/haoka',
      component: () => import('./views/user/haoka.vue'),
      meta: { title: '免费领取' }
    },
    // {
    //   path: '/user/applygdtdouyingMy',
    //   component: () => import('./views/user/applygdtdouyingMy.vue'),
    //   meta: { title: '免费领取' }
    // },

    {
      path: '/user/applyTop',
      component: () => import('./views/user/applyTop.vue'),
      meta: { title: '免费领取' }
    },

    {
      path: '/user/applyHaoka1',
      component: () => import('./views/user/agentHaoka/applyHaoka1.vue'),
      meta: { title: '免费领取' }
    },
    {
      path: '/user/applyHaoka2',
      component: () => import('./views/user/agentHaoka/applyHaoka2.vue'),
      meta: { title: '免费领取' }
    },
    {
      path: '/user/applyHaoka',
      component: () => import('./views/user/agentHaoka/applyHaoka.vue'),
      meta: { title: '免费领取' }
    },
    {
      path: '/user/applyHaokaMy',
      component: () => import('./views/user/agentHaoka/applyHaokaMy.vue'),
      meta: { title: '免费领取' }
    },
    {
      path: '/user/applySims',
      component: () => import('./views/user/apply.vue'),
      meta: { title: '免费领取' }
    },
    {
      path: '/user/chgApply',
      component: () => import('./views/user/chgApply.vue'),
      meta: { title: '换卡' }
    },
    {
      path: '/user/chgCmcc',
      component: () => import('./views/user/chgCmcc.vue'),
      meta: { title: '换卡' }
    },
    {
      path: '/user/applySimCmcc',
      component: () => import('./views/user/applyCmcc.vue'),
      meta: { title: '免费领取' }
    },
    {
      path: '/user/applyuc',
      component: () => import('./views/user/applyuc.vue'),
      meta: { title: '免费领取' }
    },
    {
      path: '/user/applygdss',
      component: () => import('./views/user/applyguangdian.vue'),
      meta: { title: '免费领取' }
    },
    {
      path: '/user/applyCmccMy',
      component: () => import('./views/user/applyCmccMy.vue'),
      meta: { title: '免费领取' }
    },
    {
      path: '/user/cardOpen',
      component: () => import('./views/user/other/cardSetUp.vue'),
      meta: { title: '开户中心' }
    },

    {
      path: '/user/payBack',
      component: () => import('./views/user/other/payBack.vue'),
      meta: { title: '支付完成' }
    },

    {
      path: '/user/cuccLog',
      component: () => import('./views/user/cuccLog.vue'),
      meta: { title: '实名教程' }
    },
    {
      path: '/user/cmcclog',
      component: () => import('./views/user/cmcclog.vue'),
      meta: { title: '实名教程' }
    },
    {
      path: '/user/cmcclog1',
      component: () => import('./views/user/cmcclog1.vue'),
      meta: { title: '实名教程' }
    },
    {
      path: '/user/cuccAuth',
      component: () => import('./views/user/other/cuccAuth.vue'),
      meta: { title: '实名登记' }
    },
    {
      path: '/user/cmccAuth',
      component: () => import('./views/user/other/cmccAuth.vue'),
      meta: { title: '实名登记' }
    },
    {
      path: '/user/cmccAuths',
      component: () => import('./views/user/cmccAuth.vue'),
      meta: { title: '实名登记' }
    },
    {
      path: '/user/loginPrice',
      component: () => import('./views/user/loginPrice.vue'),
      meta: { title: '业务办理' }
    },
    {
      path: '/user/sim',
      component: () => import('./views/user/other/login.vue'),
      meta: { title: '登录中心' }
    },
    {
      path: '/user/queryFlux',
      component: () => import('./views/user/queryFlux.vue'),
      meta: { title: '流量查询' }
    },
    {
      path: '/user/rechargePrice',
      name: 'rechargePrice',
      component: () => import('./views/user/rechargePrice.vue'),
      meta: { title: '套餐订购' }
    },
    {
      path: '/user/rechargeSure',
      name: 'rechargeSure',
      component: () => import('./views/user/rechargeSure.vue'),
      meta: { title: '确认支付' }
    },

    {
      path: '/user/rechargePriceTo',
      name: 'rechargePriceTo',
      component: () => import('./views/user/rechargePriceTo.vue'),
      meta: { title: '预存活动' }
    },

    {
      path: '/user/recharge',
      name: 'recharge',
      component: () => import('./views/user/recharge.vue'),
      meta: { title: '套餐订购' }
    },

    {
      path: '/user/buyRecharge',
      component: () => import('./views/user/buyRecharge.vue'),
      meta: { title: '套餐订购' }
    },
    {
      path: '/user/verified',
      component: () => import('./views/user/verified.vue'),
      meta: { title: '实名认证' }
    },
    {
      path: '/user/rechargeDetail',
      name: 'rechargeDetail',
      component: () => import('./views/user/rechargeDetail.vue'),
      meta: { title: '充值详情' }
    },

    {
      path: '/user/feedback',
      redirect: '/user/feedback/list',
      component: () => import('./views/user/simTui/feedback.vue'),
      children: [
        {
          path: 'list',
          component: () => import('./views/user/simTui/question.vue')
        },
        {
          path: 'question',
          component: () => import('./views/user/simTui/submitQuestion.vue')
        }
      ],
      meta: { title: '好友推广' }
    },


    {
      path: '/user/questionDetail',
      component: () => import('./views/user/simTui/questionDetail.vue'),
      meta: { title: '问题详情' }
    },
    {
      path: '/user/userChgCardLogin',
      component: () => import('./views/user/userChgCardLogin.vue'),
      meta: { title: '换卡中心' }
    },
    {
      path: '/user/chgCardQuery',
      component: () => import('./views/user/chgCardQuery.vue'),
      meta: { title: '换卡中心' }
    },
    {
      path: '/user/userChgCard',
      name: 'userChgCard',
      component: () => import('./views/user/userChgCard.vue'),
      meta: { title: '换卡中心' }
    },
    {
      path: '/user/userChgCardPay',
      name: 'userChgCardPay',
      component: () => import('./views/user/userChgCardPay.vue'),
      meta: { title: '换卡中心' }
    },
    {
      path: '/agent/login',
      component: () => import('./views/agent/login.vue'),
      meta: { title: '商户登录' }
    },
    {
      path: '/agent/home',
      component: () => import('./views/agent/home.vue'),
      meta: { title: '业务中心' }
    },
    {
      path: '/agent/secondBack',
      component: () => import('./views/agent/secondBack.vue'),
      meta: { title: '秒返设置' }
    },
    {
      path: '/agent/distribut',
      component: () => import('./views/agent/simDistribut.vue'),
      meta: { title: '卡片分销' }
    },
    {
      path: '/agent/notify',
      component: () => import('./views/agent/notify.vue'),
      meta: { title: '我的公告' }
    },
    {
      path: '/agent/notifyDetail',
      name: 'notifyDetail',
      component: () => import('./views/agent/notifyDetail.vue'),
      meta: { title: '公告详情' }
    },
    {
      path: '/agent/distributRecord',
      component: () => import('./views/agent/distributRecord.vue'),
      meta: { title: '分销记录' }
    },
    {
      path: '/agent/recharge',
      component: () => import('./views/agent/recharge.vue'),
      meta: { title: '预充值' }
    },
    {
      path: '/agent/rechargeRecord',
      component: () => import('./views/agent/rechargeRecord.vue'),
      meta: { title: '预充值记录' }
    },
    {
      path: '/agent/onlineService',
      component: () => import('./views/agent/onlineService.vue'),
      meta: { title: '在线客服' }
    },
    {
      path: '/user/couponToReceive',
      component: () => import('./views/user/couponToReceive.vue'),
      meta: { title: '领券中心' }
    },
    {
      path: '/user/cardSetUp',
      component: () => import('./views/user/balanceRecharge.vue'),
      meta: { title: '充值中心' }
    },
    {
      path: '/user/balanceRecharge',
      name: 'balanceRecharge',
      component: () => import('./views/user/balanceRecharge.vue'),
      meta: { title: '余额充值' }
    },
    {
      path: '/user/balanceRechargeRecord',
      component: () => import('./views/user/balanceRechargeRecord.vue'),
      meta: { title: '充值记录' }
    },
    {
      path: '/user/notify',
      component: () => import('./views/user/notify.vue'),
      meta: { title: '我的公告' }
    },
    {
      path: '/user/loginReload',
      component: () => import('./views/user/loginReload.vue'),
      meta: { title: '刷新网络' }
    },
    {
      path: '/user/returnPostage',
      component: () => import('./views/user/returnPostage.vue'),
      meta: { title: '邮费退还' }
    },
    {
      path: '/user/rechargeSale',
      component: () => import('./views/user/rechargeSale.vue'),
      meta: { title: '限时套餐' }
    },
    {
      path: '/user/simLoginSale',
      component: () => import('./views/user/simLoginSale.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/user/Advertisement',
      component: () => import('./components/Advertisement.vue'),
      meta: { title: '聚量广告' }
    },
    {
      path: '/appFeedback',
      component: () => import('./views/appFeedback.vue')
    },
    {
      path: '/appSignin',
      component: () => import('./views/appSignin.vue')
    },
    {
      path: '/integralRecord',
      component: () => import('./views/integralRecord.vue')
    },
    {
      path: '/luckywheel',
      component: () => import('./views/luckywheel.vue')
    },
    {
      path: '/drawGuide',
      component: () => import('./views/drawGuide.vue')
    },
    {
      path: '/goExchange',
      component: () => import('./views/goExchange.vue')
    },
    {
      path: '/cancelRealName',
      component: () => import('./views/user/cancelRealName.vue')
    },
    {
      path: '/user/loginBInd',
      component: () => import('./views/user/loginBInd.vue'),
      meta: { title: '实名' }
    },
    {
      path: '/user/haokaByEx',
      component: () => import('./views/user/haokaByEx.vue'),
      meta: { title: '免费领取-包邮到家' }
    },

    {
      path: '/user/haokaByEx9',
      component: () => import('./views/user/haokaByEx9.vue'),
      meta: { title: '免费领取-包邮到家' }
    },
    {
      path: '/user/haokaByEx1',
      component: () => import('./views/user/haokaByEx1.vue'),
      meta: { title: '免费领取-包邮到家' }
    },

    {
      path: '/user/otherbindPhone',
      component: () => import('./views/user/otherbindPhone.vue'),
      meta: { title: '实名认证' }
    },
    {
      path: '/user/loginActive',
      component: () => import('./views/user/loginActive.vue'),
      meta: { title: '一键复机' }
    },
    {
      path: '/smoke',
      component: () => import('./views/smoke/index.vue'),
      meta: { title: '查找附近门店' }
    },
    {
      path: '/smoke/details',
      component: () => import('./views/smoke/details.vue'),
      meta: { title: '门店详情' }
    },
    {
      path: '/activity',
      component: () => import('./views/activity/index.vue'),
      meta: { title: '活动' }
    },
    {
      path: '/cuccAuth',
      component: () => import('./views/cucc.vue'),
      meta: { title: '实名' }
    },
    {
      path: '/loadp',
      component: () => import('./views/loadp.vue'),
      meta: { title: '下载' }
    },
    {
      path: '/user/huodong',
      name: 'juanhuodong',
      component: () => import('./views/user/huodong.vue'),
      meta: { title: '活动中心' }
    },
    {
      path: '/newUser/huodong',
      name: 'juanhuodongNew',
      component: () => import('./views/newUser/huodong.vue'),
      meta: { title: '活动中心' }
    },
    {
      path: '/user/payOrder',
      component: () => import('./views/user/aliHtml.vue'),
      meta: { title: '订单支付' }
    },

    {
      path: '/user/coupon',
      name: 'coupon',
      component: () => import('./views/user/coupon.vue'),
      meta: { title: '活动余额' }
    },

    {
      path: '/user/applyxHaoka',
      component: () => import('./views/user/applyHaoka/applyHaoka.vue'),
      meta: { title: '免费领取-包邮到家' }
    },
    {
      path: '/user/applyPhone',
      component: () => import('./views/user/applyHaoka/applyPhone.vue'),
      meta: { title: '免费领取-包邮到家' }
    },
    {
      path: '/user/phonelist',
      component: () => import('./views/user/applyHaoka/phonelist.vue'),
      meta: { title: '免费领取-包邮到家' }
    },
    {
      path: '/user/haokaApply1',
      component: () => import('./views/user/applyHaoka/haokaApply1.vue'),
      meta: { title: '免费领取-包邮到家' }
    },

    {
      path: '/user/haokaApply21',
      component: () => import('./views/user/applyHaoka/haokaApply21.vue'),
      meta: { title: '免费领取-包邮到家' }
    },
    {
      path: '/user/haokaApply22',
      component: () => import('./views/user/applyHaoka/haokaApply22.vue'),
      meta: { title: '免费领取-包邮到家' }
    },
    {
      path: '/user/haokaApply23',
      component: () => import('./views/user/applyHaoka/haokaApply23.vue'),
      meta: { title: '免费领取-包邮到家' }
    },



    {
      path: '/user/haokaApply23',
      component: () => import('./views/user/applyHaoka/haokaApply23.vue'),
      meta: { title: '免费领取-包邮到家' }
    },
    {
      path: '/user/haokaApply24',
      component: () => import('./views/user/applyHaoka/haokaApply24.vue'),
      meta: { title: '免费领取-包邮到家' }
    }, ,
    // {
    //   path: '/user/applygdtdouyingTui',
    //   component: () => import('./views/user/applygdtdouyingTui.vue'),
    //   meta: { title: '免费领取' }
    // },,
    {
      path: '/user/applygdtdouyingYw',
      component: () => import('./views/user/apply/applygdtdouyingYw.vue'),
      meta: { title: '免费领取' }
    },
    {
      path: '/user/applygdtdouyingYy',
      component: () => import('./views/user/apply/applygdtdouyingYy.vue'),
      meta: { title: '免费领取' }
    },
    {
      path: '/user/applygdtdouyingWx',
      component: () => import('./views/user/apply/applygdtdouyingWx.vue'),
      meta: { title: '免费领取' }
    },
    {
      path: '/user/applygdtdouyingApp',
      component: () => import('./views/user/apply/applygdtdouyingApp.vue'),
      meta: { title: '免费领取' }
    },
    {
      path: '/user/ay',
      component: () => import('./views/user/apply/applygdtdouyingApp.vue'),
      meta: { title: '免费领取' }
    },
    {
      path: '/user/applygdtdouyingSoul',
      component: () => import('./views/user/apply/applygdtdouyingSoul.vue'),
      meta: { title: '免费领取' }
    },

    {
      path: '/user/successPage',
      component: () => import('./views/user/apply/successPage.vue'),
      meta: { title: '领取成功' }
    },







    {
      path: '/user/applygdtdouying1',
      component: () => import('./views/user/apply/applygdtdouying1.vue'),
      meta: { title: '免费领取' }
    },









    {
      path: '/user/applygdtdouying82',
      component: () => import('./views/user/apply/applygdtdouying82.vue'),
      meta: { title: '免费领取' }
    },












    ,







    {
      path: '/user/applygdtdouyingPay1',
      component: () => import('./views/user/applyPay/applygdtdouyingPay1.vue'),
      meta: { title: '限时活动' }
    },


    {
      path: '/user/userLogin',
      component: () => import('./views/user/userLogin.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/user/recommend',
      component: () => import('./views/user/recommend.vue'),
      meta: { title: '推荐' }
    },
    {
      path: '/user/buyShebeiSelect',
      component: () => import('./views/user/buyShebeiSelect.vue'),
      meta: { title: '查询订单' }
    },

    {
      path: '/user/aliUrl',
      component: () => import('./views/user/AppAPay.vue'),
      meta: { title: '支付' }
    },
    {
      path: '/user/aliMaPay',
      component: () => import('./views/user/aliMaPay.vue'),
      meta: { title: '支付' }
    },

    {
      path: '/user/wxUrl',
      component: () => import('./views/user/AppAwxPay.vue'),
      meta: { title: '支付' }
    },


    // 新版本
    // {
    //   path: '/newUser/simLogin',
    //   component: () => import('./views/newUser/bindNew/bindPhone.vue'),
    //   meta: { title: '登录' }
    // },
    {
      path: '/newUser/simLogin',
      component: () => import('./views/newUser/simLogin.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/newUser/tousuBack',
      component: () => import('./views/newUser/tousuBack.vue'),
      meta: { title: '注销申请' }
    },


    {
      path: '/user/buyShebei',
      component: () => import('./views/user/buyShebei.vue'),
      meta: { title: '设备专区' }
    },
    {
      path: '/user/buyShebeiInfo',
      component: () => import('./views/user/buyShebeiInfo.vue'),
      meta: { title: '设备详情' }
    },
    {
      path: '/wu/buyShebeiInfo',
      component: () => import('./views/wu/buyShebeiInfo.vue'),
      meta: { title: '设备详情' }
    },
    {
      path: '/xin/buyShebeiInfo',
      component: () => import('./views/xin/buyShebeiInfo.vue'),
      meta: { title: '设备详情' }
    },
    {
      path: '/newUser/backSelect',
      component: () => import('./views/newUser/backSelect.vue'),
      meta: { title: '退款查询' }
    },
     {
      path: '/newUser/cityOutSelect',
      component: () => import('./views/newUser/cityOutSelect.vue'),
      meta: { title: '区域限制管理' }
    },
    {
      path: '/newUser/pkgSelect',
      component: () => import('./views/newUser/pkgSelect.vue'),
      meta: { title: '套餐查询' }
    },


    {
      path: '/newUser/simLoginNo',
      component: () => import('./views/newUser/simLoginNo.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/newUser/newOpen',
      component: () => import('./views/newUser/newOpen.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simOpenSj',
      component: () => import('./views/newUser/simOpenSj.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simAllOpen',
      component: () => import('./views/newUser/simAllOpen.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simAllOpenPkg',
      component: () => import('./views/newUser/simAllOpenPkg.vue'),
      meta: { title: '优惠套餐' }
    },

    {
      path: '/newUser/simAllOpenThree',
      component: () => import('./views/newUser/simAllOpenThree.vue'),
      meta: { title: '地区专属优惠' }
    },


    {
      path: '/newUser/simOpenPayTest',
      component: () => import('./views/newUser/simOpenPayTest.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/newOpen1',
      component: () => import('./views/newUser/newOpen1.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/newOpen2',
      component: () => import('./views/newUser/newOpen2.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simOpenZb',
      component: () => import('./views/newUser/simOpenZb.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simKefu',
      component: () => import('./views/newUser/simKefu.vue'),
      meta: { title: '联系客服' }
    },
    {
      path: '/newUser/simKefuTo',
      component: () => import('./views/newUser/simKefuTo.vue'),
      meta: { title: '用户详情' }
    },
    {
      path: '/newUser/simOpenTnPUp',
      component: () => import('./views/newUser/simOpenTnPUp.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/newOpen3',
      component: () => import('./views/newUser/newOpen3.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/newOpen4',
      component: () => import('./views/newUser/newOpen4.vue'),
      meta: { title: '优惠活动' }
    },
    {
      path: '/newUser/simLoginBase',
      component: () => import('./views/newUser/simLogins.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/newUser/phoneLogin',
      component: () => import('./views/newUser/phoneLogin.vue'),
      meta: { title: '手机号绑定' }
    },
    {
      path: '/newUser/phoneCode',
      component: () => import('./views/newUser/phoneCode.vue'),
      meta: { title: '手机号绑定' }
    },
    {
      path: '/newUser/home',
      component: () => import('./views/newUser/home.vue'),
      meta: { title: '首页' }
    },
    {
      path: '/newUser/haoka',
      component: () => import('./views/newUser/haoka.vue'),
      meta: { title: '' }
    },

    {
      path: '/newUser/diagnosis',
      component: () => import('./views/newUser/diagnosis.vue'),
      meta: { title: '诊断' }
    },
    {
      path: '/newUser/recharge',
      component: () => import('./views/newUser/recharge.vue'),
      meta: { title: '余额充值' }
    },
    {
      path: '/newUser/coupon',
      component: () => import('./views/newUser/coupon.vue'),
      meta: { title: '活动余额' }
    },
    {
      path: '/newUser/problem',
      component: () => import('./views/newUser/problem.vue'),
      meta: { title: '常见问题' }
    },
    {
      path: '/newUser/problemDetails',
      component: () => import('./views/newUser/problemDetails.vue'),
      meta: { title: '常见问题' }
    },
    {
      path: '/newUser/entrance',
      component: () => import('./views/newUser/entrance.vue'),
      meta: { title: '投诉' }
    },
    {
      path: '/newUser/complaint',
      component: () => import('./views/newUser/complaint.vue'),
      meta: { title: '提交投诉' }
    },
    {
      path: '/newUser/complaintHistory',
      component: () => import('./views/newUser/complaintHistory.vue'),
      meta: { title: '投诉历史' }
    },
    {
      path: '/newUser/complaintResult',
      component: () => import('./views/newUser/complaintResult.vue'),
      meta: { title: '投诉详情' }
    },
    {
      path: '/newUser/operation',
      component: () => import('./views/newUser/operation.vue'),
      meta: { title: '更多功能' }
    },
    {
      path: '/newUser/bindPhone',
      component: () => import('./views/newUser/bindPhone.vue'),
      meta: { title: '绑定手机号' }
    },
    {
      path: '/newUser/bindPhoneBase',
      component: () => import('./views/newUser/bindPhoneBase.vue'),
      meta: { title: '绑定手机号' }
    },
    {
      path: '/newUser/firstHome',
      component: () => import('./views/newUser/firstHome.vue'),
      meta: { title: '绑定卡号' }
    },





    //新加的
    {
      path: '/new/serviceCenter',
      component: () => import('./views/new/serviceCenter.vue'),
      meta: { title: '业务中心' }
    },
    {
      path: '/new/successfully',
      component: () => import('./views/new/successfully.vue'),
      meta: { title: '充值成功' }
    },
    {
      path: '/new/equipmentCard',
      component: () => import('./views/new/equipmentCard.vue'),
      meta: { title: '绑定设备卡' }
    },
    {
      path: '/new/order',
      component: () => import('./views/new/order.vue'),
      meta: { title: '订购流量套餐' }
    },
    {
      path: '/new/bindCard',
      component: () => import('./views/new/bindCard.vue'),
      meta: { title: '绑定设备卡' }
    },
    {
      path: '/new/coupon',
      component: () => import('./views/new/coupon.vue'),
      meta: { title: '选中优惠劵' }
    },
    {
      path: '/new/yue',
      component: () => import('./views/new/yue.vue'),
      meta: { title: '卡内余额' }
    },



    {
      path: '/ndai/buyShebei',
      component: () => import('./views/ndai/buyShebei.vue'),
      meta: { title: '首页' }
    },
    {
      path: '/ndai/userInfo',
      component: () => import('./views/ndai/userInfo.vue'),
      meta: { title: '我的' }
    },
    {
      path: '/ndai/bindPhone',
      component: () => import('./views/ndai/bindPhone.vue'),
      meta: { title: '注册登录' }
    },
    {
      path: '/ndai/sumbit',
      component: () => import('./views/ndai/sumbit.vue'),
      meta: { title: '提交订单' }
    },
    {
      path: '/ndai/selectOrder',
      component: () => import('./views/ndai/selectOrder.vue'),
      meta: { title: '订单查询' }
    },



    {
      path: '/ydai/buyShebei',
      component: () => import('./views/ydai/buyShebei.vue'),
      meta: { title: '首页' }
    },
    {
      path: '/ydai/userInfo',
      component: () => import('./views/ydai/userInfo.vue'),
      meta: { title: '我的' }
    },
    {
      path: '/ydai/bindPhone',
      component: () => import('./views/ydai/bindPhone.vue'),
      meta: { title: '注册登录' }
    },
    {
      path: '/ydai/sumbit',
      component: () => import('./views/ydai/sumbit.vue'),
      meta: { title: '提交订单' }
    },
    {
      path: '/ydai/selectOrder',
      component: () => import('./views/ydai/selectOrder.vue'),
      meta: { title: '订单查询' }
    },



    {
      path: '/liu/buyShebei',
      component: () => import('./views/liu/buyShebei.vue'),
      meta: { title: '首页' }
    },
    {
      path: '/liu/userInfo',
      component: () => import('./views/liu/userInfo.vue'),
      meta: { title: '我的' }
    },
    {
      path: '/liu/bindPhone',
      component: () => import('./views/liu/bindPhone.vue'),
      meta: { title: '注册登录' }
    },
    {
      path: '/liu/sumbit',
      component: () => import('./views/liu/sumbit.vue'),
      meta: { title: '提交订单' }
    },
    {
      path: '/liu/selectOrder',
      component: () => import('./views/liu/selectOrder.vue'),
      meta: { title: '订单查询' }
    },






    {
      path: '/wen/home',
      component: () => import('./views/wen/home.vue'),
      meta: { title: '首页' }
    },
    {
      path: '/wen/order',
      component: () => import('./views/wen/order.vue'),
      meta: { title: '订单' }
    },
    {
      path: '/wen/userInfo',
      component: () => import('./views/wen/userInfo.vue'),
      meta: { title: '我的' }
    },
    {
      path: '/wen/login',
      component: () => import('./views/wen/login.vue'),
      meta: { title: '登录' }
    },


    {
      path: '/hai/home',
      component: () => import('./views/hai/home.vue'),
      meta: { title: '首页' }
    },
    {
      path: '/hai/order',
      component: () => import('./views/hai/order.vue'),
      meta: { title: '订单' }
    },
    {
      path: '/hai/userInfo',
      component: () => import('./views/hai/userInfo.vue'),
      meta: { title: '我的' }
    },
    {
      path: '/hai/login',
      component: () => import('./views/hai/login.vue'),
      meta: { title: '登录' }
    },


    {
      path: '/yao/home',
      component: () => import('./views/yao/home.vue'),
      meta: { title: '首页' }
    },
    {
      path: '/yao/order',
      component: () => import('./views/yao/order.vue'),
      meta: { title: '订单' }
    },
    {
      path: '/yao/userInfo',
      component: () => import('./views/yao/userInfo.vue'),
      meta: { title: '我的' }
    },
    {
      path: '/yao/login',
      component: () => import('./views/yao/login.vue'),
      meta: { title: '登录' }
    },

  ]
})